<template>
  <div class="generalSidebar">
    <el-menu class="sidebarGeneral" ref="menu">
      <div class="link summary" :class="{active: !deviceInfo.sn}"  @click="toggleDevice({pn:'',sn:'',devcode:'',devaddr:''})">
        <span class="topTotal">
          <i class="iconfont icon-device"></i>
          <span class="title">{{$t('statistic.totalDevice')}}</span>
        </span>
        <!-- <i class="el-icon-arrow-down arrow"></i> -->
      </div>
      <div class="menu-container">
        <el-menu-item v-for="(item,index) in deviceList" :key="index" class="menu-item">
          <div class="link item" @click="toggleDevice(item)" :class="{active: deviceInfo.devcode===item.devcode&&deviceInfo.pn===item.pn&&deviceInfo.devaddr===item.devaddr&&deviceInfo.sn===item.sn}">
            <i :class="statusDic[item.status].class" class="status-icon"></i>
            <span class="title">{{item.devalias || item.sn}}</span>
          </div>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    deviceList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo'
    }),
  },
  data() {
    return {
      statusDic: this.$filter.deviceStatus
    };
  },
  methods: {
    toggleDevice(info) {
      // console.log("overview-click");
      this.$store.commit('saveDeviceInfo', info)
    }
  },
};
</script>
<style lang="less" scoped>
.sidebarGeneral {
  display: flex;
  flex-direction: column;
  .summary {
    padding-right: 20px;
    justify-content: space-between;
    &.active .arrow {
      color: #fff;
    }
    .topTotal{
      display: flex;
      align-items: center;
    }
  }
  .menu-container {
    flex: 1;
    overflow: auto;
    .status-icon {
      width: 14px;
      height: 14px;
      margin-right: 10px;
      padding-right: 14px;
    }
    .menu-item {
      height: 40px;
      .item {
        height: 40px;
        padding-left: 44px;
        // margin: auto 20px
      }
    }
  }
}
</style>

